@if (isLoading) {
<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<h2 class="panel-title">{{ 'Modules.XPACManagementComponent.XpacLicenseComponent.TitleLicenseInfo' | translate }}</h2>

<form class="form-container" [formGroup]="formGroupXPACInfo">
  <app-input formControlName="hasSubscription" type="switch"
    label="{{ 'Modules.XPACManagementComponent.XpacLicenseComponent.HasSubscription' | translate }}"></app-input>
  <app-input *ngIf="hasCrossPointRole()" formControlName="endDate" type="date"
    label="{{ 'Modules.XPACManagementComponent.XpacLicenseComponent.EndDate' | translate }}"></app-input>

  <ng-container *ngIf="('licenses' | hasPermission :'RemoteMaintenance_SubscriptionEndDate':'update' | async)">
    <app-input formControlName="allowCrossPoint" type="switch"
      label="{{ 'Modules.XPACManagementComponent.XpacLicenseComponent.AllowCrossPoint' | translate }}"></app-input>
    <app-input formControlName="allowPartner" type="switch"
      label="{{ 'Modules.XPACManagementComponent.XpacLicenseComponent.AllowPartner' | translate }}"></app-input>
    <app-input formControlName="allowRetailer" type="switch"
      label="{{ 'Modules.XPACManagementComponent.XpacLicenseComponent.AllowRetailer' | translate }}"></app-input>
  </ng-container>
</form>

<div class="action-buttons">
  <!-- Set end date -->
  <ng-container *ngIf="('licenses' | hasPermission :'RemoteMaintenance_SubscriptionEndDate':'update' | async)">
    <button mat-flat-button class="button small-button" (click)="cancelSubscription()">
      <mat-icon>cancel</mat-icon>
      <p>{{ 'Modules.XPACManagementComponent.XpacLicenseComponent.EndDateNow' | translate }}</p>
    </button>
  </ng-container>
</div>
}